const MasterDataEndpoint = {
  SAVE: '/cmms/master-data/save',
  SAVE_SITE: '/cmms/master-data/save-site',
  UPDATE_SITE: '/cmms/master-data/update-site',
  LOAD_SITE: '/cmms/master-data/load-site',
  LOAD_SITES_META_DATA: '/cmms/master-data/load-sites',
  DELETE_SITE: '/cmms/master-data/delete-site',
  GET: '/cmms/master-data/get',
};

export default MasterDataEndpoint;
